// Copyright (C) 2025 Sorama B.V.
import { bindable, customElement } from "aurelia-framework";
import { Router } from "aurelia-router";

@customElement("locked-feature-alert")
export class LockedFeatureAlert {
    @bindable
    public title = "";

    @bindable
    public description = "";

    @bindable
    public actionButtonText = "Go to webshop";

    @bindable
    public actionButtonUrl = "/webshop";

    @bindable
    public showActionButton = true;

    constructor(private readonly router: Router) {}

    public navigate(): void {
        if (this.actionButtonUrl) {
            // Handle both internal routes and external URLs
            if (this.actionButtonUrl.startsWith("http")) {
                window.open(this.actionButtonUrl, "_blank");
            } else {
                this.router.navigate(this.actionButtonUrl);
            }
        }
    }
}
